

import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getSubscriptionPlans,getUserStats } from '../components/DbServices';
import { appname, appnameonly } from "../variables";
import { getStoredUser } from '../utilities/encryption';

export default function Sidebar() {
  const [activeSub, setActiveSub] = useState(null);
  const [stats, setStats] = useState(null);
  const session = getStoredUser();
  const user = session?.data;
  const userId = user?.id;
  const userRole = user?.role || 'user';

  useEffect(() => {
    const fetchSub = async () => {
      try {
        const res = await getSubscriptionPlans(userId);
        if (res?.status === 200) setActiveSub(res.data?.current_subscription || null);
      } catch (err) { console.error(err); }
    };
    if (userId && userRole === 'user') fetchSub();
  }, [userId, userRole]);

  useEffect(() => {
    const fetchNavbarStats = async () => {
      try {
        if (userRole === 'user') {
          const res = await getUserStats(user.id);
          if (res?.status === 200) setStats(res.data);
        }
      } catch (err) {
        console.error("Navbar Sync Error", err);
      }
    };
    fetchNavbarStats();
  }, [user.id, userRole]);


  const currentUsage = stats?.devices_used || 0; // Adjust 'device_count' to your actual API key name
  const maxLimit = stats?.device_limit || 0;
  
  // Calculate percentage (Safety check: if maxLimit is 0, percentage is 0)
  
  const usagePercentage = maxLimit > 0 ? Math.min((currentUsage / maxLimit) * 100, 100) : 0;

  return (
    <div
      className="vh-100 text-white p-4 d-flex flex-column shadow-lg"
      style={{
        width: 260,
        background: 'linear-gradient(180deg, #4C1D95, #0E7490)', // RESTORED ORIGINAL COLOR
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 1050,
        overflowY: 'auto'
      }}
    >
      {/* BRANDING */}
      <div className="text-center mb-5 mt-2 px-2">
        <img
          src={appnameonly}
          alt={appname}
          style={{ width: '100%', maxWidth: '180px', filter: 'brightness(0) invert(1)' }}
        />
      </div>

      <div className="flex-grow-1 px-1">
        {userRole === 'admin' ? (
          /* ADMIN PORTAL */
          <>
            <p className="fw-bold opacity-50 mb-4 ps-2 text-uppercase tracking-widest" style={{ fontSize: '10px' }}>Admin Control</p>
            <NavItem to="/admin/dashboard" label="System Overview" icon="fas fa-chart-pie" />
            <NavItem to="/admin/users" label="Manage Users" icon="fas fa-user-shield" />
            <NavItem to="/admin/susbcriptions" label="Manage Susbcription Requests" icon="fas fa-user-shield" />
            <NavItem to="/plans" label="Setup Plans" icon="fas fa-gem" />
            <NavItem to="/support" label="Support" icon="fas fa-phone" />
            <NavItem to="/admin/stats" label="Global Reports" icon="fas fa-file-invoice-dollar" />
            <NavItem to="/settings" label="System Settings" icon="fas fa-sliders-h" />
          </>
        ) : (
          /* USER MENU */
          <>
            <p className="fw-bold opacity-50 mb-4 ps-2 text-uppercase tracking-widest" style={{ fontSize: '10px' }}>Main Console</p>
            <NavItem to="/dashboard" label="Overview" icon="fas fa-th-large" />
            <NavItem to="/devices" label="WhatsApp" icon="fab fa-whatsapp" />
            <NavItem to="/contacts" label="Contacts" icon="fas fa-address-book" />
            <NavItem to="/apps" label="API Keys" icon="fas fa-key" />
            <NavItem to="/sandbox" label="Sandbox" icon="fas fa-flask" />
            <NavItem to="/reports" label="Analytics" icon="fas fa-chart-bar" />
            <NavItem to="/pricing" label="Upgrade" icon="fas fa-crown text-warning" />
            <NavItem to="/integration" label="Integrations" icon="fas fa-puzzle-piece" />
            <NavItem to="/settings" label="Settings" icon="fas fa-user-cog" />
          </>
        )}
      </div>

      {/* SUBSCRIPTION WIDGET */}
      {userRole === 'user' && activeSub && (
        <div className="mt-auto p-3 rounded-4" style={{ backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)' }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <small className="fw-bold opacity-75 text-uppercase" style={{ fontSize: '9px' }}>Plan Status</small>
            <span className="badge bg-white text-primary fw-bold rounded-pill shadow-sm" style={{ fontSize: '9px' }}>{activeSub.plan_name.toUpperCase()}</span>
          </div>

          <div className="mb-2 d-flex justify-content-between fw-bold" style={{ fontSize: '11px' }}>
            <span className="opacity-75 text-white">Resources</span>
            <span className="text-white">{activeSub.device_limit} Max</span>
          </div>
          <div className="progress mb-3 bg-white bg-opacity-25" style={{ height: '5px' }}>
          <div className="progress mb-3 bg-white bg-opacity-25" style={{ height: '5px' }}>
            <div
              className={`progress-bar shadow-sm ${usagePercentage > 90 ? 'bg-danger' : 'bg-white'}`}
              role="progressbar"
              style={{ width: `${usagePercentage}%`, transition: '1.5s ease' }}
            ></div>
          </div>
          </div>

          <NavLink to="/pricing" className="btn btn-white btn-sm w-100 rounded-pill fw-bold bg-white text-dark border-0 shadow-sm" style={{ fontSize: '10px' }}>
            <i className="fas fa-rocket me-2"></i> UPGRADE NOW
          </NavLink>
        </div>
      )}

      {/* ADMIN IDENTIFIER */}
      {userRole === 'admin' && (
        <div className="mt-auto p-2 text-center rounded-3 bg-white bg-opacity-20 border border-white border-opacity-25 shadow-sm">
          <small className="fw-bold text-uppercase" style={{ fontSize: '10px', letterSpacing: '1px' }}>
            <i className="fas fa-shield-alt me-2"></i>Auth: Master
          </small>
        </div>
      )}
    </div>
  );
}

function NavItem({ to, label, icon }) {
  return (
    <NavLink
      to={to}
      className="d-flex align-items-center mb-2 text-white text-decoration-none py-2 px-3 rounded-3 transition-all"
      style={({ isActive }) => ({
        backgroundColor: isActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
        opacity: isActive ? 1 : 0.8,
        fontWeight: isActive ? '700' : '400',
        fontSize: '14px',
        borderLeft: isActive ? '4px solid #fff' : '4px solid transparent'
      })}
    >
      <div className="d-flex align-items-center justify-content-center me-3" style={{ width: '24px' }}>
        <i className={`${icon} fs-6`}></i>
      </div>
      <span>{label}</span>
    </NavLink>
  );
}